import React from "react";
import { FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
    Nav,
    NavBarContainer,
    NavLogo,
    MobileIcon,
    NavMenu,
    NavItem,
    NavLinks,
} from "./NavBarElements";
import Logo from "../../images/cpjLogo.png.png";
import { useSelector, useDispatch } from "react-redux";


const NavBar = ({ toogle }) => {
    const isLoggedIn = useSelector((state) => state.login.isLoggedIn);
    const dispatch = useDispatch();

    const logout = () => {
        localStorage.removeItem("isLoggedIn");
        window.location.replace("/");
      };

    function handleLogout() {
        dispatch(logout());
        window.location.reload();
    }
    return (
        <>
            <Nav>
                <NavBarContainer>
                    <Link to="/">
                        <NavLogo src={Logo}></NavLogo>
                    </Link>
                    <MobileIcon onClick={toogle}>
                        <FaBars />
                    </MobileIcon>
                    <NavMenu>
                        <NavItem>
                            <NavLinks

                                to="Sobrenosotros"
                                smooth={true}
                                duration={1000}
                            >
                                Sobre Nosotros
                            </NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks
                                to="Categorias"
                                smooth={true}
                                duration={1500}
                            >
                                Categorias
                            </NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks
                                to="Direccion"
                                smooth={true}
                                duration={1500}
                            >
                                Dirección
                            </NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks
                                to="Contacto"
                                smooth={true}
                                duration={1500}
                            >
                                Contacto
                            </NavLinks>
                        </NavItem>

                        <Link to="/login">
                            <img
                                src="https://cdn-icons-png.flaticon.com/512/3736/3736502.png"
                                width={50}
                                height={50}
                            />
                        </Link>
                        <Link to="/">
                            <img onClick={handleLogout}
                                src="https://cdn-icons-png.flaticon.com/512/4622/4622563.png"
                                width={50}
                                height={50}
                            />
                        </Link>
                    </NavMenu>
                </NavBarContainer>
            </Nav>
        </>
    );
};
export default NavBar;
